// extracted by mini-css-extract-plugin
module.exports = {"popup-header":"anonReviewFormPopup_popup-header__SdBVR","popup-overlay":"anonReviewFormPopup_popup-overlay__4qRlP","popup-container":"anonReviewFormPopup_popup-container__n3Lr7"};